module.exports = __webpack_public_path__ + "media/images/logo-compleet2-4fe5671320156764c0e5f3e363989b9a.svg";